<template>
  <v-container full-height
               fluid
               class="pa-0">
    <v-row class="full-height"
           no-gutters>
      <v-col cols="12"
             class="full-height">
        <v-row class="full-height"
               no-gutters>
          <!-- inicio de sidebar -->
          <v-col cols="2"
                 class="smartbell-sidebar pa-0 full-height">
          </v-col>
          <!-- fin de sidebar -->
          <v-col cols="10"
                 class="full-height std-background-white-1">
            <!-- inicio de barra superior -->
            <v-row class="pl-6 pr-12 alert-top-container mt-3 mb-6"
                   align="end"
                   justify="space-between"
                   no-gutters>
              <!-- inicio de contadores de animales -->
              <v-col cols="3" class="d-flex justify-space-between">
                <!-- inicio de contadores de vaquillas -->
                <div class="d-flex align-center std-animal-count-container justify-space-between std-background-white-1 px-2"
                     style="width: 48%">
                  <i class="std-icon std-heifer-blue-icon"></i>
                  <div class="std-text-md std-text-blue-3 font-weight-bold">008</div>
                </div>
                <!-- fin de contadores de vaquillas -->
                <!-- inicio de contadores de toros -->
                <div class="d-flex align-center std-animal-count-container justify-space-between std-background-white-1 px-2"
                     style="width: 48%">
                  <i class="std-icon std-heifer-blue-icon"></i>
                  <div class="std-text-md std-text-blue-3 font-weight-bold">008</div>
                </div>
                <!-- fin de contadores de toros -->
              </v-col>
              <!-- fin de contadores de animales -->
              <!-- inicio de cambiar de rancho -->
              <v-col cols="3" >
                <ChangeRanch
                        :paddock="paddockSelected"
                        :paddocks="currentPaddocks"
                ></ChangeRanch>
              </v-col>
              <!-- fin de cambiar de rancho -->
              <!-- inicio de tarjeta de vacas en sistema -->
              <v-col cols="3">
                <SystemCardCount height="40px"
                                 width="100%"
                                 number="100"
                                 title-background="#57A7F5"
                                 number-background="#1460AA"
                                 title="Vacas en Sistema"></SystemCardCount>
              </v-col>
              <!-- fin de tarjeta de vacas en sistema -->
            </v-row>
            <!-- fin de barra superior -->

            <!--inicio de contenedor central -->
            <v-row class="alert-main-container ml-6 mr-12 std-border-radius std-container-shadow"
                   no-gutters>
              <!-- inicio de título de tarjeta  -->
              <v-col cols="12"
                     class="std-title-card-container d-flex align-center justify-center std-text-lg std-text-white-1 font-weight-bold std-border-top-radius std-background-red-1">
                <div>Alertas de celo por confirmar</div>
              </v-col>
              <!-- fin de título de tarjeta -->
              <v-col cols="12" class="std-border-bottom-radius alert-main-content-container " >
                <!-- inicio de contenedor de alertas -->
                <v-row no-gutters class="alert-cards-container">
                  <!-- inicio de periodo de alertas -->
                  <v-col cols="4"
                         class="d-flex flex-wrap offset-1">
                    <div class="col-12 alert-cars-title-container align-center std-text-md std-text-blue-2">
                      Periodo de alertas
                    </div>
                    <div class="col-6 alert-card-container py-0">
                      <v-autocomplete
                              :items="animalTypesList"
                              item-text="text"
                              outlined
                              dense
                              hide-details
                              height="48px"
                              item-value="value"
                              v-model="animalType"
                      >
                      </v-autocomplete>
                    </div>
                    <div class="col-6 alert-card-container d-flex py-0">
                      <div class="col-12 d-flex align-center justify-space-between alert-item-container ">
                        <i class="mini-icon heat-icon"></i>
                        <div class="button-text strong-blue" style="display: inline-block">Celo</div>
                      </div>
                    </div>
                  </v-col>
                  <!-- fin de periodo de alertas -->
                  <!-- inicio de otro tipo alertas -->
                  <v-col cols="6" class=" d-flex flex-wrap justify-center">
                    <div class="col-12 alert-cars-title-container align-center std-text-md std-text-blue-2">
                      Selecciona otro tipo de alertas a revisar
                    </div>
                    <div class="col-4 alert-card-container d-flex std-disabled pa-0 px-3" @autocomplete="">
                      <div class="col-12 d-flex align-center justify-space-between alert-item-container">
                        <i class="mini-icon pregnant-icon"></i>
                        <div class="button-text strong-blue" style="display: inline-block">Preñada</div>
                      </div>
                    </div>
                    <div class="col-4 alert-card-container d-flex std-disabled pa-0 px-3">
                      <div class="col-12 d-flex align-center justify-space-between alert-item-container">
                        <i class="mini-icon calf-icon"></i>
                        <div class="button-text strong-blue" style="display: inline-block">Parto</div>
                      </div>
                    </div>
                    <div class="col-4 alert-card-container d-flex std-disabled pa-0 px-3">
                      <div class="col-12 d-flex align-center justify-space-between alert-item-container">
                        <i class="mini-icon sick-icon"></i>
                        <div class="button-text strong-blue" style="display: inline-block">Salud</div>
                      </div>
                    </div>
                  </v-col>
                  <!-- fin de otro tipo alertas -->
                </v-row>
                <!-- fin de contenedor de alertas -->
                <!-- inicio contenedor de fecha -->
                <v-row no-gutters
                       class="mt-4 mb-2 alert-date-container">
                  <v-col cols="12"
                         class="d-flex justify-center align-center">
                    <div class="col-3 pa-0">
                      <v-dialog
                              ref="dialog"
                              v-model="modal"
                              :return-value.sync="date"
                              persistent
                              width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                                  v-model="date"
                                  readonly
                                  dense
                                  solo
                                  flat
                                  hide-details
                                  single-line
                                  v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                                v-model="date"
                                scrollable
                                locale="es-419">
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>

                    </div>
                  </v-col>
                </v-row>
                <!-- fin de contenedor de fecha -->
                <!-- inicio contenedor de tabla -->
                <v-row no-gutters
                       align="start"
                       justify="center"
                       class="alert-table-container">
                  <v-col cols="11" class="full-height px-4">
                    <v-row class="full-height"
                           no-gutters>
                      <v-col cols="12"
                             class="full-height d-flex justify-center flex-wrap">
                        <!-- inicio de header de tabla -->
                        <div class="std-table-header d-flex align-center justify-center col-11 px-0 std-text-md font-weight-bold">
                          <div class=" col-4 d-flex justify-center align-center">
                            ID Vaca
                            <i class="std-vertical-arrow-icon"></i>
                          </div>
                          <div class="col-2 d-flex justify-center align-center">
                            Raza<i class="std-vertical-arrow-icon"></i>
                          </div>
                          <div class=" col-2 d-flex justify-center align-center">
                            DIM<i class="std-vertical-arrow-icon"></i>
                          </div>
                          <div class=" col-3 d-flex justify-center align-center">
                            Grupo<i class="std-vertical-arrow-icon"></i>
                          </div>
                          <div class=" col-1 d-flex justify-center align-center">
                          </div>
                        </div>
                        <!-- fin de header de tabla -->
                        <!-- inicio de contenido de tabla -->
                        <v-row no-gutters
                               class="alert-table-row-container col-12 pa-0"
                               id="row-container"
                               justify="center"
                               align-content="start">
                          <v-col cols="11" class="d-flex align-center justify-center alert-table-row"
                                 style="position: relative"
                                 v-for="(item, index) in croppedHistory" :key="index"
                                 v-bind:class="[{'first-row' : index === 0}]">
                            <i class="da-table-icon"></i>
                            <div class="col-4 d-flex align-center justify-center " style="position:relative;">
                              <div class="col-12 align-center justify-center d-flex px-0">
                                <div class="col-3 pa-0 offset-3 d-flex justify-center">
                                  <div style="display: block">{{item.id}}</div>
                                </div>
                                <div class="col-3 pa-0 d-flex pl-4" style="display: block">
                                  <div class="d-inline-flex mr-1">
                                    <i class="ds-ltl-icon ds-kpi"></i>
                                  </div>
                                  <div class="d-inline-flex mr-1">
                                  <i class="ds-ltl-icon ds-kpi"></i>
                                  </div>
                                  <div class="d-inline-flex mr-1">
                                  <i class="ds-ltl-icon ds-kpi"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-2 d-flex align-center justify-center ">
                              {{item.breed}}
                            </div>
                            <div class="col-2 d-flex align-center justify-center">
                              {{item.dim}}
                            </div>
                            <div class="col-3 d-flex align-center justify-center">
                              {{item.group}}
                            </div>
                            <div class="col-1 d-flex align-center justify-center ">
                            </div>
                            <v-switch v-model="item.alertSwitch"
                                      class="ma-2 da-switch-table">
                            </v-switch>
                          </v-col>
                        </v-row>
                        <!-- fin de contenido de tabla -->
                        <!-- inicio de paginación -->
                        <v-row no-gutters class="alert-table-pagination-container col-11 pa-0">
                          <v-col cols="12"
                                 style="position: relative;"
                                 class="d-flex align-center pa-0 justify-center">
                            <v-pagination v-model="pageSelected"
                                          class="col-6"
                                          :disabled="itemsPage === 0"
                                          :length="itemsPage"
                                          :next-icon="nextIcon"
                                          :prev-icon="prevIcon"
                                          total-visible="10"
                            >
                            </v-pagination>
                            <v-autocomplete :items="pageItems"
                                            :disabled="itemsPage === 0"
                                            return-object
                                            outlined
                                            hide-details
                                            dense
                                            style="position: absolute; right: 24px"
                                            v-model="pageItem"
                                            value="number"
                                            item-text="formattedText">
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <!-- inicio de paginación -->
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <!-- fin de contenedor de tabla -->
              </v-col>
            </v-row>
            <!-- fin de contenedor central -->

          </v-col>

        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import ChangeRanch from '../components/ChangeRanch.vue';
    import SystemCardCount from "../components/SystemCardCount";
    export default {
        name: 'Home',
        data () {
            return {
                date: new Date().toISOString().substr(0, 10),
                menu: false,
                modal: false,
                menu2: false,
                animalTypesList: [{text: 'Vacas', value: 'cows'}, {text: 'Vaquillas', value: 'heifers' }, {text: 'Toros', value: 'bulls'}],
                animalType: this.$store.getters.animalTypeSelected,
                success: false,
                pageSelected: 1,
                nextIcon: 'navigate_next',
                prevIcon: 'navigate_before',
                pageItem: {number: 5, formattedText: '5 eventos por hoja'},
                itemsToShow: [
                    {
                        id: '0001',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0002',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0003',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0004',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0004',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                    {
                        id: '0004',
                        dim: 190,
                        breed: 'Holstein',
                        group: 'General',
                        alertSwitch: false,
                    },
                ],
                pageItems: [
                    {number: 5, formattedText: '5 eventos por hoja'},
                    {number: 20, formattedText: '20 eventos por hoja'},
                    {number: 30, formattedText: '30 eventos por hoja'},
                    {number: 40, formattedText: '40 eventos por hoja'},
                ],
            }
        },
        components: {
            ChangeRanch,
            SystemCardCount
        },
        computed: {
            userData(){
                return this.$store.getters.getUserData
            },
            animals() {
                return this.$store.getters.getAnimals;
            },
            numberOfAnimals() {
                if(this.$store.getters.getAnimals.length < 10){
                    return "00"+this.$store.getters.getAnimals.length;
                } else if(this.$store.getters.getAnimals.length < 100){
                    return "0"+this.$store.getters.getAnimals.length;
                } else if(this.$store.getters.getAnimals.length >= 100){
                    return this.$store.getters.getAnimals.length;
                }
                return 0
            },
            /**
             * Obtiene el último rancho seleccionado desde la store
             * para posteriormente pasarlo como prop al componente
             * changeRanch
             * @returns {getters.getPaddockSelected}
             */
            paddockSelected() {
                return this.$store.getters.getPaddockSelected;
            },
            /**
             * Obtiene los ranchos actuales en el sistema desde la store
             * para posteriormente pasarlo como prop al componente
             * changeRanch
             * @returns {getters.getPaddockSelected}
             */
            currentPaddocks() {
                return this.$store.getters.getPaddocks;
            },
            /**
             * Calcula el número de páginas que mostrará la paginación
             */
            itemsPage() {
                return Math.floor(this.itemsToShow.length / this.pageItem.number) + 1;
            },
            isActive(index) {
                return index === 0;
            },
            /**
             * Regresa los elementos de la bitácora de acuerdo a los eventos
             * por hoja seleccionados por el usuario
             */
            croppedHistory() {
                return this.itemsToShow.slice((this.pageSelected - 1) * this.pageItem.number, this.pageSelected * this.pageItem.number);
            },
        },
        watch: {
        },
        methods: {
            openPage(page){
                this.$router.push({ name: page })
            },
            imprimeHola() {
                console.log('Hola');
            }
        },
        mounted () {
            this.$store.commit('renderNav',true);
            if (this.$store.getters.getUserData.onboarding === false){
                this.$router.push({name:'Onboarding'});
            }
            console.log(this.itemsToShow)
        }
    };
</script>

<style lang="css">
  @import '../style/DashAlert.css';
</style>

